import React from 'react';
import Navbar from './Navbar';
import { Route, Routes, useNavigate } from 'react-router-dom';
import LandingPage from '../../Pages/LandingPages/landingPage';
import Login from '../../Pages/Authentication/Login';
import ForgotPassword from '../../Pages/Authentication/Forgetpassword';
import About from '../../Pages/LandingPages/About';
import Blog from '../../Pages/LandingPages/Blog';
import SingleBlog from '../../Pages/LandingPages/SingleBlog';
import Property from '../../Pages/Dashboard/Property';
import CoporateSignUp from '../SignUp/Cooperate';
import Viewproperty from '../../Pages/Dashboard/Viewproperty';

function Layout() {
  const navigate = useNavigate();
  const scrollToDiv =  () => {
    navigate('/', { state: { scrollTo: 'targetDiv' } });
  };
  return (
    <div>
      <Navbar onContact={scrollToDiv} />
      <div>
        <Routes>
          <Route index element={<LandingPage />} />
          <Route path='/register' element={<CoporateSignUp />} />
          <Route path='/login' element={<Login />} />
          <Route path='/forgotpassword' element={<ForgotPassword />} />
          <Route path='/viewProperty' element={<Viewproperty />} />
          <Route path='/about' element={<About />} />
          <Route path='/property' element={<Property />} />
          <Route path='/blog' element={<Blog />} />
          <Route path='/blog/:id' element={<SingleBlog />} />
        </Routes>
      </div>
    </div>
  );
}
export default Layout;
